import React from 'react';
import { ArrowLeft, FileText } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { logoUrl } from '../mockData';
import QuotazioneForm from '../components/QuotazioneForm';

const Quotazione = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <button
              onClick={() => navigate('/')}
              className="flex items-center space-x-2 text-[#2B7A9F] hover:text-[#3AAFA9] transition-colors duration-300"
            >
              <ArrowLeft size={20} />
              <span className="font-medium">Torna alla Home</span>
            </button>
            <img src={logoUrl} alt="Assietica" className="h-12 w-auto" />
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#2B7A9F] to-[#3AAFA9] text-white py-12 sm:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="w-16 h-16 bg-white/20 backdrop-blur-md rounded-full flex items-center justify-center mx-auto mb-6">
            <FileText className="text-white" size={32} />
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold mb-4">
            Scheda di Quotazione
          </h1>
          <p className="text-lg text-white/90 max-w-2xl mx-auto">
            Compila il modulo per ricevere una quotazione personalizzata per le esigenze assicurative 
            del tuo Ente del Terzo Settore o della tua Cooperativa.
          </p>
        </div>
      </div>

      {/* Form Section */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 -mt-8">
        <QuotazioneForm />
      </main>

      {/* Info Box */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
        <div className="bg-[#F9D424]/10 rounded-xl p-6 border border-[#F9D424]/30">
          <h3 className="font-semibold text-gray-800 mb-3">Hai bisogno di assistenza?</h3>
          <p className="text-gray-600 text-sm mb-4">
            Se hai difficoltà nella compilazione o preferisci un contatto diretto, siamo a disposizione:
          </p>
          <div className="flex flex-wrap gap-4 text-sm">
            <a href="tel:+390785747193" className="text-[#2B7A9F] hover:underline">
              📞 0785 747193
            </a>
            <a href="tel:+393737288673" className="text-[#2B7A9F] hover:underline">
              📱 373 7288673
            </a>
            <a href="mailto:agenzia@assietica.it" className="text-[#2B7A9F] hover:underline">
              ✉️ agenzia@assietica.it
            </a>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-[#17536B] text-white py-6">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="text-sm text-white/70">
            © {new Date().getFullYear()} Assietica Società Cooperativa. Tutti i diritti riservati.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Quotazione;
